import { useEffect, useState, useMemo } from "react";
import Button from "../components/Common/Button";
import Header from "../components/Common/Header";
import TabsComponent from "../components/Dashboard/Tabs";
import { get100Coins } from "../functions/get100Coins";

function Watchlist() {
  const [coins, setCoins] = useState([]);
  
  // Wrap watchlist in useMemo to prevent unnecessary changes
  const watchlist = useMemo(() => {
    return JSON.parse(localStorage.getItem("watchlist")) || [];
  }, []); // Empty dependency array means it only calculates once

  useEffect(() => {
    const getData = async () => {
      if (watchlist.length > 0) {
        const allCoins = await get100Coins();
        if (allCoins) {
          setCoins(allCoins.filter((coin) => watchlist.includes(coin.id)));
        }
      } else {
        setCoins([]); // Clear coins if watchlist is empty
      }
    };

    getData();
  }, [watchlist]); // watchlist is now stable

  return (
    <div>
      <Header />
      {watchlist.length > 0 && coins.length > 0 ? (
        <TabsComponent coins={coins} />
      ) : (
        <div>
          <h1 style={{ textAlign: "center" }}>
            Sorry, No Items In The Watchlist.
          </h1>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "2rem",
            }}
          >
            <a href="/dashboard">
              <Button text="Dashboard" />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default Watchlist;